import MockAdapter from 'axios-mock-adapter';
import { axiosInstance } from '../../services/useResource';
import { mockedPartnerData } from '../mockedPartnerData';

const mock = new MockAdapter(axiosInstance, { onNoMatch: 'passthrough', delayResponse: 1000 });

mock.onGet(new RegExp('https://api.eih-netbroker.com/1235/available-subscriptions')).reply(() => {
  return [200, mockedPartnerData];
});
